var exports = {
  "uu": "VoiceLobbyShared.module__actionButtons___dVJiY1",
  "hP": "VoiceLobbyShared.module__actionButton___dVJiY1",
  "zc": "VoiceLobbyShared.module__iconContainer___dVJiY1",
  "KA": "VoiceLobbyShared.module__iconContainerBrand___dVJiY1",
  "cF": "VoiceLobbyShared.module__iconContainerDanger___dVJiY1",
  "hO": "VoiceLobbyShared.module__iconContainerTertiary___dVJiY1",
  "cY": "VoiceLobbyShared.module__iconContainerSuccess___dVJiY1",
  "gE": "VoiceLobbyShared.module__actionIcon___dVJiY1",
  "uI": "VoiceLobbyShared.module__actionIconSecondary___dVJiY1",
  "K2": "VoiceLobbyShared.module__actionText___dVJiY1",
  "Hd": "VoiceLobbyShared.module__connectionInfo___dVJiY1",
  "Il": "VoiceLobbyShared.module__connectionHeader___dVJiY1",
  "p1": "VoiceLobbyShared.module__connectionStatusInfo___dVJiY1",
  "bn": "VoiceLobbyShared.module__connectionTitle___dVJiY1",
  "fV": "VoiceLobbyShared.module__connectionSubtitle___dVJiY1",
  "Cb": "VoiceLobbyShared.module__connectionStatusDot___dVJiY1",
  "wL": "VoiceLobbyShared.module__statsGrid___dVJiY1",
  "N8": "VoiceLobbyShared.module__statRow___dVJiY1",
  "Zh": "VoiceLobbyShared.module__statLabel___dVJiY1",
  "cR": "VoiceLobbyShared.module__statValue___dVJiY1",
  "_x": "VoiceLobbyShared.module__statValuePrimary___dVJiY1",
  "V4": "VoiceLobbyShared.module__endpointValue___dVJiY1",
  "TR": "VoiceLobbyShared.module__connectionIdValue___dVJiY1",
  "JX": "VoiceLobbyShared.module__maxWidth___dVJiY1",
};

module.exports = exports;
